const DEFAULT_LEADS_LIST_TABLE_HEADERS = [
  { label: 'Lead Name', key: 'name', search: true, sort: true },
  { label: 'email', key: 'email', search: true, sort: true },
  { label: 'phone', key: 'cell_phone', search: true, sort: true },
  {
    label: 'zip',
    key: 'zip_postal_code',
    search: true,
    sort: true,
    width: '100px',
  },
  {
    label: 'LEAD CAPTURE DATE',
    key: 'creation_timestamp',
    search: true,
    sort: true,
    width: '150px',
    wrap: true,
  },
  { label: 'Type', key: 'lead_type', search: true, sort: true, width: '80px' },
  {
    label: 'LEAD SOURCE',
    key: 'source',
    search: true,
    sort: true,
    width: '50px',
    wrap: true,
  },
  {
    label: 'APPOINTMENT TIME',
    key: 'appointment_time',
    search: false,
    sort: false,
    width: '160px',
    wrap: true,
  },
  {
    label: 'LATEST FOLLOWUP STATUS',
    key: 'followup_status_label',
    search: true,
    sort: true,
    width: '180px',
    wrap: true,
  },
  {
    label: 'DEACTIVATE FOLLOWUP',
    key: 'followup_optout',
    search: false,
    sort: false,
    width: '120px',
    wrap: true,
  },
];

export const LEADS_LIST_TABLE_HEADERS = (userType) =>
  userType === 'BOOMERS_ADMIN'
    ? [
        ...DEFAULT_LEADS_LIST_TABLE_HEADERS,
        {
          label: 'BILLABLE',
          key: 'billable',
          search: false,
          sort: true,
          width: '80px',
        },
        {
          label: 'ACTIONS',
          key: 'action',
          search: false,
          sort: false,
          width: '70px',
        },
      ]
    : [
        ...DEFAULT_LEADS_LIST_TABLE_HEADERS,
        {
          label: 'DETAILS',
          key: 'action',
          search: false,
          sort: false,
          width: '70px',
        },
      ];
